import { ViewMode } from '../../../hooks/viewMode';
import {
  optionsForVehicleStatus,
  optionsForVehicleGear,
  optionsForVehicleFuelType,
  optionsForVehicleBlockReasons,
  optionsForSupportedVehicleConnections,
  optionsForVehicleConnection,
} from '../assets/optionsForVehicle';
import {
  optionsForClaimStatus,
  optionsForClaimTripIgnition,
  optionsForClaimCloseReason,
} from '../assets/optionsForClaim';
import {
  optionsForServiceStatus,
  optionsForServiceType,
} from '../assets/optionsForCare';
import {
  optionsForUserStatus,
  optionsForCWStatus,
  optionsForCardStatus,
  optionsForUserType,
  optionsForBlockReason,
  optionsForBlockReasonDetails,
  optionsForManualApproval,
} from '../assets/optionsForUsers';
import { optionsForTripStatus } from '../assets/optionsForTrips';
import { optionsForBookingStatus } from '../assets/optionsForBookings';
import { optionsForReceiptType } from '../assets/optionsForReceipts';
import { optionsForFuelTransactionType } from '../assets/optionsForFuelTransactions';
import {
  optionsForReportStatus,
  optionsForReportType,
  optionsForReportLocale,
} from '../assets/optionsForReports';

const optionMapper = {
  [ViewMode.VEHICLE]: {
    status: optionsForVehicleStatus,
    gear: optionsForVehicleGear,
    fuel: optionsForVehicleFuelType,
    blockReasons: optionsForVehicleBlockReasons,
    supportedVehicleConnections: optionsForSupportedVehicleConnections,
    vehicleConnection: optionsForVehicleConnection,
  },
  [ViewMode.CLAIM]: {
    status: optionsForClaimStatus,
    tripIgnition: optionsForClaimTripIgnition,
    closeReason: optionsForClaimCloseReason,
  },
  [ViewMode.CARE]: {
    status: optionsForServiceStatus,
    serviceTypes: optionsForServiceType,
  },
  [ViewMode.SHARE]: {
    status: optionsForTripStatus,
  },
  [ViewMode.BOOKING]: {
    status: optionsForBookingStatus,
  },
  [ViewMode.USERS]: {
    accountStatus: optionsForUserStatus,
    'creditworthinessData.creditWorthinessStatus': optionsForCWStatus,
    'identityDocuments.[0].status': optionsForCardStatus,
    'licenses.[0].licenseStatus': optionsForCardStatus,
    userType: optionsForUserType,
    blockReason: optionsForBlockReason,
    blockReasonDetails: optionsForBlockReasonDetails,
    manualApproval: optionsForManualApproval,
  },
  [ViewMode.RECEIPTS]: {
    receiptType: optionsForReceiptType,
  },
  [ViewMode.FUEL_TRANSACTIONS]: {
    type: optionsForFuelTransactionType,
  },
  [ViewMode.REPORTS]: {
    status: optionsForReportStatus,
    type: optionsForReportType,
    locale: optionsForReportLocale,
  },
};

const getOptionValues = (vm: any, target: any) => {
  // @ts-ignore
  return optionMapper[vm]?.[target] || [];
};

export default getOptionValues;
